export default __webpack_public_path__ + "static/media/raki_side.0f88830c.jpg";